import { ExtractInput } from "../extract-input";
import { ExtractOutput } from "../extract-output";
import { extractEditor } from "../utils/extract-editor";

export function extractSelectV1(
  extractInput: ExtractInput,
): ExtractOutput<string> {
  const { version, questionType } = extractInput;

  return {
    version,
    questionType,
    entryCount: 1,
    answerSheet: "",
  };
}

export function extractStudentSelectV1(
  extractInput: ExtractInput,
): ExtractOutput<string> {
  const { version, questionType, div } = extractInput;

  const editor = extractEditor(div);
  const selected = editor.querySelector('input[name="question"]:checked');
  return {
    version,
    questionType,
    entryCount: 1,
    answerSheet: selected?.id ?? "",
  };
}
